import { createFeatureSelector, createSelector } from '@ngrx/store'
import { TUTORIAL_VIDEOS_FEATURE_KEY, TutorialVideosState, tutorialVideosAdapter } from './tutorial-videos.reducer'

export const selectTutorialVideosState = createFeatureSelector<TutorialVideosState>(TUTORIAL_VIDEOS_FEATURE_KEY)

const { selectAll, selectEntities } = tutorialVideosAdapter.getSelectors()

export const selectTutorialVideosLoaded = createSelector(
  selectTutorialVideosState,
  (state: TutorialVideosState) => state.loaded,
)

export const selectAllTutorialVideos = createSelector(selectTutorialVideosState, (state: TutorialVideosState) =>
  selectAll(state),
)

export const selectTutorialVideosEntities = createSelector(selectTutorialVideosState, (state: TutorialVideosState) =>
  selectEntities(state),
)

export const selectSelectedId = createSelector(
  selectTutorialVideosState,
  (state: TutorialVideosState) => state.selectedId,
)

export const selectEntity = createSelector(selectTutorialVideosEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const selectShowingVideo = createSelector(
  selectTutorialVideosState,
  (state: TutorialVideosState) => state.showingVideo,
)

export const selectEditCreateLoaded = createSelector(
  selectTutorialVideosState,
  (state: TutorialVideosState) => state.editCreateLoaded,
)
